import { render, staticRenderFns } from "./authPhone.vue?vue&type=template&id=0c6cb118&scoped=true"
import script from "./authPhone.vue?vue&type=script&lang=js"
export * from "./authPhone.vue?vue&type=script&lang=js"
import style0 from "./authPhone.vue?vue&type=style&index=0&id=0c6cb118&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6cb118",
  null
  
)

export default component.exports